const INITIAL_STATE = {
  serviceId: null,
  tag: null,
  source: null,
  open: null,
  close: null,
  onChange: null,
  onFinish: null,
  answers: null,
  isOpen: false,
  finished: false,
  isFormAddress: false,
  address: null,
  selectedAddress: null,
  company_id: null,
};

/**
 * Types
 */
export const Types = {
  CHANGE_FORM: 'serviceForm/CHANGE',
  FINISH_FORM_REQUEST: 'serviceForm/FINISH_FORM_REQUEST',
  FINISH_FORM_SUCCESS: 'serviceForm/FINISH_FORM_SUCCESS',
  OPEN_FORM: 'serviceForm/OPEN',
  CLOSE_FORM: 'serviceForm/CLOSE',
};

/**
 * Reducer
 */
export default function auth(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.CHANGE_FORM:
      return { ...state, answers: action.payload };
    case Types.FINISH_FORM_SUCCESS:
      return INITIAL_STATE;
    case Types.OPEN_FORM:
      return { ...INITIAL_STATE, ...action.payload };
    case Types.CLOSE_FORM:
      return INITIAL_STATE;
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  changeForm: payload => ({
    type: Types.CHANGE_FORM,
    payload,
  }),

  finishFormRequest: payload => ({
    type: Types.FINISH_FORM_REQUEST,
    payload,
  }),

  finishFormSuccess: () => ({
    type: Types.FINISH_FORM_SUCCESS,
  }),

  openForm: payload => ({
    type: Types.OPEN_FORM,
    payload,
  }),

  closeForm: () => ({
    type: Types.CLOSE_FORM,
  }),
};
